import { useOptimizelyFeatureFlag } from '@shared/v2/contexts/optimizely';

import { flags } from '@/v2/constants/featureFlags';

export const useTravellingToFilter = () => {
  const [decision, clientReady] = useOptimizelyFeatureFlag(
    flags.TRAVELLING_TO_FILTER.key,
  );

  return {
    showTravellingToFilter:
      clientReady &&
      decision?.variationKey !==
        flags.TRAVELLING_TO_FILTER.variations.HIDE_TRAVELLING_TO_FILTER,
  };
};
